import { ancestorVoice } from "@/lib/api";

const cache = new Map(); // ancestor id -> audio data URL
let current = null;

export function stopBlessing() {
  if (current) {
    current.pause();
    current = null;
  }
}

// Fetches (and caches) an ancestor's spoken blessing, then plays it.
export async function playBlessing(id) {
  stopBlessing();
  let src = cache.get(id);
  if (!src) {
    const data = await ancestorVoice(id);
    src = `data:audio/mp3;base64,${data.audio}`;
    cache.set(id, src);
  }
  const audio = new Audio(src);
  current = audio;
  audio.addEventListener("ended", () => {
    if (current === audio) current = null;
  });
  await audio.play();
  return audio;
}
